import { Component, ChangeDetectionStrategy, TemplateRef, ViewChild } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'iris-project-select-dropdown-group-item',
  templateUrl: './dropdown-group-item.component.html',
  styles: `:host { display: none; }`,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TranslateModule,
  ],
  standalone: true,
})
export class IrisProjectSelectDropdownGroupItemComponent {

  @ViewChild('template', { static: true }) template: TemplateRef<unknown>;
}
